import { Http, Response, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class ArrivalService {

  constructor(private http: Http, private authHttp: AuthHttp) { }

  addToArrival(arrival: any) {
    return this.authHttp.post('/api/arrival/', arrival).map(res => {
      return { 'status': res.status, 'value': res.json() };
    });
  }

  getAllArrivals() {
    return this.http.get('/api/arrival/').map(res => res.json());
  }

  delete(id: number) {
    return this.authHttp.delete('/api/arrival/' + id).map(res => res.json());
  }

   downloadExcel() {
      return this.authHttp.get('/api/arrival/generateXlsx', { responseType: ResponseContentType.Blob }).map((res: Response) => {
        return res
      });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/arrival.service.ts